import { Record } from 'immutable';

import ModelTrimConfigurationModel from 'commons-vehicle/ModelYear/models/ModelTrimConfigurationModel.js';

const OptionsPackageRecord = Record({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    rank: 0,
    configuration: new ModelTrimConfigurationModel(),
});

class OptionsPackage extends OptionsPackageRecord {
    getSelectionCode() {
        return this.get('selectionCode');
    }
}

export default OptionsPackage;



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/ModelYear/models/OptionsPackageModel.js